import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "chevron"]

  toggle(event) {
    event.preventDefault()
    this.panelTarget.classList.toggle("d-none")

    if (this.hasChevronTarget) {
      const hidden = this.panelTarget.classList.contains("d-none")
      this.chevronTarget.style.transform = hidden ? "rotate(-90deg)" : ""
    }
  }
}
